export function shouldPollEpisode(episode: { status: string; promptGenerationStatus?: string }): boolean {
  if (episode.status === 'pending') {
    return episode.promptGenerationStatus === 'generating';
  }
  return [
    'generating_shots',
    'pending_normalization',
    'normalizing',
    'pending_pronoun_resolve',
    'resolving_pronouns',
  ].includes(episode.status);
}
